<template>
  <div>
    <timesheet-field :layout="collapsibleToggleLayout" :value="collapsibleToggleLayout.value" @change="onChange" />
    <template v-if="layoutData.is_expanded === true">
      <timesheet-fieldset v-for="(field, index) in enabledFields" :key="index" :layout="field" @change="onChange" />
    </template>
  </div>
</template>

<script>
  import TimesheetField from '../field/TimesheetField.vue';
  import TimesheetFieldset from '../TimesheetFieldset.vue'
  export default {
    components: { 
      TimesheetFieldset: () => import('../TimesheetFieldset.vue'),
      TimesheetField 
    },
    name: "timesheet-group-collapsible",
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout,
        collapsibleToggleLayout: {
          label: this.layout.label,
          type: "multistate",
          options: [
            { label: "Oui", value: 1 },
            { label: "Non", value: 0 }
          ],
          value: this.layout.is_expanded === true ? 1 : 0
        }
      }
    },
    computed: {
      enabledFields() {
        return this.layoutData.fields.filter(e => e.enabled !== false); 
      },
    },
    methods: {
      onChange(e,l,v,i) {
        this.$set(this.layoutData, "is_expanded", this.collapsibleToggleLayout.value == 1);
        this.$emit("change", e, l, v, i)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>